import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class WorkOrderSearchResultDto {
    community: string;
    communityId: number;
    location: string;
    workOrderId: number;
    taskIds: string;
    jobType: string;
    workDescription: string;

    @Type(() => UserNameDisplayResultDto)
    createdBy: UserNameDisplayResultDto;

    status: string;

    @Type(() => Date)
    dueDate: Date;

    hasNotes: boolean;
    vendor: string;
    vendorId: number;
    workOrderVendorId: number;
}
